import { render, staticRenderFns } from "./CaseGroups.vue?vue&type=template&id=a6bc90d2&"
import script from "./CaseGroups.vue?vue&type=script&lang=js&"
export * from "./CaseGroups.vue?vue&type=script&lang=js&"
import style0 from "./CaseGroups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports